import React, { useEffect, useState, useRef } from "react";
import "./portraitList.css";
import "../portraitSlider/portraitSlider.css";
import { getPlaylist, getAWSUrl } from "../api/core";
import SectionHeader from "../sectionHeader/sectionHeader";
import Global from "../../global";
import Anchor from "../Link/anchor";
import { Link } from "react-router-dom";
import { favourited, favourites } from "../javascript/function";
import { UserStore } from "../store/store";
import LazyImg from "../lazy/lazy";
import Icon from "../icon/icon";
import { BORDER } from "../../global";

const PortraitList = (props) => {
  const mounted = useRef(false);
  const init = { playlist: [] };
  const [plstelem, setPLSTElem] = useState([]);
  const [plstelemItem, setPLSTItem] = useState([]);
  const [plstplaylist, setPLSTPlaylist] = useState(init);
  const [loading, isLoading] = useState(true);
  /* eslint-disable no-unused-vars */
  const [error, SetError] = useState(false);
  const [elemplstdisplay, setPLSTElemDisplay] = useState(true);
  const [desc, setDesc] = useState(false);
  /* eslint-disable no-unused-vars */
  const [news, setNews] = useState(false);
  /* eslint-disable no-unused-vars */
  const [viewplstAll, setViewplstAll] = useState("");
  const [viewplstLink, setviewplstLink] = useState("");
  const currentUser = UserStore.useState((s) => s.user);

  useEffect(() => {
    mounted.current = true;
    const PLSTElemDetail = async (app, id) => {
      if (mounted.current) {
        /* eslint-disable no-unused-vars */
        setPLSTElem(props.tabbed ? props.tabid : props.information);
        setPLSTElemDisplay(
          props.tabbed
            ? props.tabid.devices[0].itemVisibility
            : props.information.devices[0].itemVisibility
        );
        setPLSTItem(props.tabbed ? props.tabid.items : props.information.items);

        if (!props.tabbed) {
          if (
            props.information.playlistId !== null &&
            props.information.playlistId !== ""
          ) {
            PLSTplaylistDetail(
              props.information.playlistId,
              props.information.devices[0].itemSize
            );
          }

          props.information.displayNameVisibility === "On Hover" ||
          props.information.displayNameVisibility === "Show Always" ||
          props.information.displayNameVisibility === "Show Header Only"
            ? setDesc(true)
            : setDesc(false);
          props.information.displayNameVisibility === "Show Always"
            ? setNews(true)
            : setNews(false);
          props.information.viewAllVisibility === true &&
          props.information.viewAllText !== null
            ? setViewplstAll(props.information.viewAllText)
            : setViewplstAll("");
          if (
            props.information.viewAllVisibility === true &&
            props.information.viewAllPage !== null
          ) {
            const link =
              props.information.viewAllPage.pageType === "externalPage"
                ? props.information.viewAllPage.externalPage
                : props.information.viewAllPage.pageType === "internalPage"
                ? props.information.viewAllPage.internalPage
                : "/" +
                  props.match.params.AppId +
                  "/" +
                  props.information.viewAllPage.pageType +
                  "/" +
                  props.information.viewAllPage._id;
            setviewplstLink(link);
          }
        } else {
          if (
            props.tabid.playlistId !== null &&
            props.tabid.playlistId !== ""
          ) {
            PLSTplaylistDetail(
              props.tabid.playlistId,
              props.tabid.devices[0].itemSize
            );
          }

          props.tabid.displayNameVisibility === "On Hover" ||
          props.tabid.displayNameVisibility === "Show Always" ||
          props.tabid.displayNameVisibility === "Show Header Only"
            ? setDesc(true)
            : setDesc(false);
          props.tabid.displayNameVisibility === "Show Always"
            ? setNews(true)
            : setNews(false);
          props.tabid.viewAllVisibility === true &&
          props.tabid.viewAllText !== null
            ? setViewplstAll(props.tabid.viewAllText)
            : setViewplstAll("");
          if (
            props.tabid.viewAllVisibility === true &&
            props.tabid.viewAllPage !== null
          ) {
            const link =
              props.tabid.viewAllPage.pageType === "externalPage"
                ? props.tabid.viewAllPage.externalPage
                : props.tabid.viewAllPage.pageType === "internalPage"
                ? props.tabid.viewAllPage.internalPage
                : "/" +
                  props.match.params.AppId +
                  "/" +
                  props.tabid.viewAllPage.pageType +
                  "/" +
                  props.tabid.viewAllPage._id;
            setviewplstLink(link);
          }
        }
      }
      /* eslint-disable no-unused-vars */
    };

    const PLSTplaylistDetail = async (id, limit) => {
      /* eslint-disable no-unused-vars */
      if (mounted.current) {
        const result = await getPlaylist(id, limit).then(
          (result) => {
            setPLSTPlaylist(result.data);
          },
          (error) => {}
        );
      }
      /* eslint-disable no-unused-vars */
    };

    PLSTElemDetail();
    isLoading(false);

    return () => {
      mounted.current = false;
    };
  }, [props.match.params.AppId, props.information, props.tabid, props.tabbed]);
  if (
    elemplstdisplay &&
    !error &&
    !loading &&
    (props.information || props.tabid)
  ) {
    return (
      <div>
        <SectionHeader
          title={plstelem.displayName}
          linkTitle={viewplstAll}
          link={viewplstLink}
          header={props.header}
        ></SectionHeader>
        <div
          className="portrait_List"
          style={{ paddingBottom: props.tabbed ? "20px" : "10px" }}
        >
          <div className="container-fluid">
            {plstelemItem !== null
              ? plstelemItem.map((item, index) =>
                  item.itemid.devices[0].itemVisibility ? (
                    <div className="list-item" key={index}>
                      <Anchor
                        className={BORDER ? "slide-one" : "slide-one no-border"}
                        to={
                          item.itemid.pageType === "externalPage"
                            ? item.itemid.externalPage
                            : item.itemid.pageType === "internalPage"
                            ? item.itemid.internalPage
                            : item.itemid.pageType === "videoPage"
                            ? props.match.params.AppId +
                              "/" +
                              item.itemid.pageType +
                              "/" +
                              item.itemid.videoId
                            : item.itemid.urlName !== ""
                            ? "/" +
                              props.match.params.AppId +
                              "/" +
                              item.itemid.urlName
                            : item.itemid.pageType + "/" + item.itemid._id
                        }
                      >
                        <div
                          className={
                            BORDER ? "slide-image" : "slide-image no-border"
                          }
                        >
                          <LazyImg
                            src={
                              item.itemid.portraitThumbnail
                                ? getAWSUrl() +
                                  item.itemid.portraitThumbnail.imagekey
                                : ""
                            }
                            alt="Carousel"
                          />
                        </div>
                        <div
                          className={
                            desc ? "slide-content" : "slide-content hidden"
                          }
                        >
                          <h2>
                            {item.itemid.displayName}{" "}
                            {Global.FAVOURITES ? (
                              <span
                                className="span"
                                onClick={(event) => {
                                  favourites(event, item.itemid, "page");
                                }}
                              >
                                {" "}
                                <i
                                  className={
                                    favourited(
                                      item.itemid._id,
                                      currentUser.FAVOURITES
                                    )
                                      ? "ri-check-fill"
                                      : "ri-add-line"
                                  }
                                ></i>
                              </span>
                            ) : (
                              ""
                            )}
                          </h2>
                          <div>
                            <span className="tag">{item.itemid.rating}</span>
                            <span className="tag"></span>
                          </div>
                          <p>{item.itemid.description}</p>
                        </div>
                      </Anchor>
                    </div>
                  ) : (
                    <div
                      key={index}
                      className="none"
                      style={{ display: "none" }}
                    ></div>
                  )
                )
              : ""}

            {plstelem.playlistId !== null && plstelem.playlistId !== undefined
              ? plstplaylist.playlist.map((item, index) => (
                  <div className="list-item" key={index}>
                    <Link
                      className={BORDER ? "slide-one" : "slide-one no-border"}
                      to={
                        "/" +
                        props.match.params.AppId +
                        "/videoPage/" +
                        item.mediaid
                      }
                    >
                      {item.ContentType === "Premium" ? <Icon></Icon> : ""}
                      <div
                        className={
                          BORDER ? "slide-image" : "slide-image no-border"
                        }
                      >
                        <LazyImg
                          src={item.PortraitImage ? item.PortraitImage : ""}
                          alt="Carousel"
                        />
                      </div>
                      <div
                        className={
                          desc ? "slide-content" : "slide-content hidden"
                        }
                      >
                        <h2>
                          {item.title}{" "}
                          {Global.FAVOURITES ? (
                            <span
                              className="span"
                              onClick={(event) => {
                                favourites(event, item, "video");
                              }}
                            >
                              {" "}
                              <i
                                className={
                                  favourited(
                                    item.mediaid,
                                    currentUser.FAVOURITES
                                  )
                                    ? "ri-check-fill"
                                    : "ri-add-line"
                                }
                              ></i>
                            </span>
                          ) : (
                            ""
                          )}
                        </h2>
                        <div>
                          <span className="tag">{item.VIdeoDuration}</span>
                          <span className="tag">{item.PgRating}</span>
                        </div>
                        <p>{item.ShortDescription}</p>
                      </div>
                    </Link>
                  </div>
                ))
              : ""}
          </div>
        </div>
      </div>
    );
  } else if (elemplstdisplay && !error && loading) {
    return <div style={{ minHeight: "400px" }}></div>;
  } else {
    return <div></div>;
  }
};

export default PortraitList;
